var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextValignTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 5,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18182 9.5H28.8182C30.0208 9.5 31 8.93898 31 8.25C31 7.56102 30.0208 7 28.8182 7H9.18182C7.97924 7 7 7.56102 7 8.25C7 8.93898 7.97924 9.5 9.18182 9.5Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6667 16.0222C23.2222 16.4 22.5556 16.4 22.1111 16.0222L20.1111 14.3222V29.0556C20.1111 29.6222 19.6667 30 19 30C18.3333 30 17.8889 29.6222 17.8889 29.0556V14.3222L15.8889 16.0222C15.4444 16.4 14.7778 16.4 14.3333 16.0222C13.8889 15.6444 13.8889 15.0778 14.3333 14.7L18.2222 11.3944C18.4444 11.2056 18.7778 11.1111 19 11.1111C19.2222 11.1111 19.5556 11.2056 19.7778 11.3944L23.6667 14.7C24.1111 15.0778 24.1111 15.7389 23.6667 16.0222Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextValignTop);
export default __webpack_public_path__ + "static/media/text_valign_top.048db0b7ae0b99254004507dadf8642c.svg";
export { ForwardRef as ReactComponent };